import { Component, OnChanges, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PipelineAssetLink2Dto, PipelineDetailsDto, LandTitleDto, SubSubGroupDto, CategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { PipelineassetpopupComponent } from '../../pipelineassetpopup/pipelineassetpopup.component';

@Component({
  selector: 'cradua-pipelineassetlink',
  templateUrl: './pipelineassetlink.component.html',
  styleUrls: ['./pipelineassetlink.component.scss']
})
export class PipelineassetlinkComponent implements OnChanges {
  
  pipelineassetlinkForm: FormGroup;
  @Input() selectedPipelineDetails: PipelineDetailsDto;
  @Input() pipelineassetlink2s: PipelineAssetLink2Dto[];
  @Input() pipelineassets: LandTitleDto[];
  @Input() subsubgroups: SubSubGroupDto[];
  @Input() categorys: CategoryDto[];
  @Input() pipelinedetails: any[];
  @Output() emitSave = new EventEmitter<PipelineAssetLink2Dto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Input() isLoadingPipelineassetlink2s: boolean;
  AssetList: any[] = [];
  selectedId: any;
  filteredDelete: Array<any> =[];
  listView = true;
  gridView = false;
  
  constructor(private fb: FormBuilder, public dialog: MatDialog) { }

  ngOnChanges(): void {
    this.pipelineassetlinkForm = this.fb.group({PipelineAssetLinks: this.fb.array([])});
    if(this.pipelineassetlink2s != null && this.pipelineassetlink2s.length) {
      this.setPipelineAssetLink(this.pipelineassetlink2s);
    }          
  }

  setPipelineAssetLink(pipelineAssetLink2s: PipelineAssetLink2Dto[]) {
    pipelineAssetLink2s.forEach(value => {
      this.control().push(this.fb.group({
          LandName: [value.LandName, Validators.required],
          LandTitleId: value.id,
          SubSubGroupName: value.SubSubGroupName,
          CategoryName: value.CategoryName,
          AutoSerialId: value.AutoSerialId,
          SubscriberId: value.SubscriberId,
          SubscriptionUserId: value.SubscriptionUserId,
          id: value.id
        })
      );
     });  
   }

   public errorHandling = (control: string, error: string) => {
    return this.pipelineassetlinkForm.controls[control].hasError(error);
  };

  onCreate() {
    this.pipelineassetlinkForm.reset();
    
  }

  onPatchValue(value) {
    this.pipelineassetlinkForm.patchValue({
      LandName: value.LandName,
      LandTitleId: value.id,
      SubSubGroupName: value.SubSubGroupName,
      CategoryName: value.CategoryName,
      // id: value.id
    });
  }

  getPipeline(id) {
    return this.pipelinedetails.find(pipeline => pipeline.PipelineCode === id);
  }

  onDelete(value, index) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.control().removeAt(index);
        for ( let i = 0; i < this.pipelineassetlink2s.length; i++) {
            if (i === index) {
              if (value.id !== null) {
                this.filteredDelete.push(this.pipelineassetlink2s[index].id);
                this.deleteEvent.emit(this.filteredDelete);
                this.filteredDelete = [];
              }
            }
          }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  control() {
    return this.pipelineassetlinkForm.controls.PipelineAssetLinks as FormArray;
  }

  onPopUpDisplay(event) {
    console.log("incident ...: ", event);
    const listdata = [];
  

    event.map(dat => {

      const data  = {
        SubSubGroupName: "",
        CategoryName: "", 
        LandName: dat.LandName,
        SubSubGroupId: dat.SubSubGroupId,
        CategoryId: dat.CategoryId,
        AutoSerialId: this.selectedPipelineDetails.id,
        SubscriberId: dat.SubscriberId,
        SubscriptionUserId: dat.SubscriptionUserId,
      };
      const subgroup = this.subsubgroups.find(sub => sub.id === dat.SubSubGroupId);
      const category =  this.categorys.find(cat => cat.id === dat.CategoryId);
      
      if(subgroup) {
        data.SubSubGroupName = subgroup.SubSubGroupName
      }
      if(category) {
        data.CategoryName = category.CategoryName
      }

      listdata.push(data);

    });
    
    const senddata = {listdata: listdata, pipelineassetlink2s: this.pipelineassetlink2s}
    const dialogRef = this.dialog
      .open(PipelineassetpopupComponent, {
        data: senddata,
        height: 'auto',
        width: '900px'
      })
      .afterClosed()
      .subscribe(datum => {
        if(datum) {
          const control = this.pipelineassetlinkForm.controls.PipelineAssetLinks as FormArray;
          datum.forEach(e => {
                control.push(this.fb.group({
                LandName: e[0].LandName,
                LandTitleId: e[0].id,
                SubSubGroupName: e[0].SubSubGroupName,
                CategoryName: e[0].CategoryName,
                AutoSerialId: this.selectedPipelineDetails.id
              })
           );
           console.log('pipe to submit form value12: ', control);
          });
        }
      });
  }

  onSubmit(formValue) {
    // const value =(this.pipelineassetlinkForm.get('PipelineAssetLinks')['controls'] as FormArray)
    console.log('pipe to submit form value12: ', formValue);

    // formValue.AutoSerialId = this.selectedPipelineDetails.id;
    // formValue.SubscriberId = this.selectedPipelineDetails.SubscriberId;
    // formValue.SubscriptionUserId = this.selectedPipelineDetails.SubscriptionUserId;
    if(this.pipelineassetlinkForm.valid){
      console.log('pipe to submit form value: ', formValue);

      this.emitSave.emit(formValue['PipelineAssetLinks']);
    }
  }
}
